import React, { useState, useEffect } from 'react';
import './FeedbackPopup.css';
import { INTERVIEWMANAGEMENT_URL } from '../../../Services/courseService';

const FeedbackPopup = ({ interviewId, userId, userName, userEmail, onClose }) => {
  const [selectedRating, setSelectedRating] = useState(0);
  const [wasHelpful, setWasHelpful] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [feedbackComment, setFeedbackComment] = useState('');
  const [isFeedbackSubmitted, setIsFeedbackSubmitted] = useState(true);

  useEffect(() => {
    const checkFeedbackStatus = async () => {
      const response = await fetch(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/${interviewId}/is-feedback-submitted`);
      const feedbackStatus = await response.json();
      setIsFeedbackSubmitted(feedbackStatus);
    };
    checkFeedbackStatus();
  }, [interviewId]);

  const handleStarClick = (rating) => {
    setSelectedRating(rating);
  };

  const handleHelpfulnessChange = (event) => {
    setWasHelpful(event.target.checked);
  };

  const handleCommentChange = (event) => {
    setFeedbackComment(event.target.value);
  };

  const handleSubmit = async () => {
    const feedbackRequest = {
      userName,
      userEmail, 
      rating: selectedRating,
      wasHelpful,
      comments: feedbackComment,
    };

    const response = await fetch(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/${userId}/${interviewId}/feedback`, {
      method: 'POST',
      body: JSON.stringify(feedbackRequest),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      setIsSubmitted(true);
      onClose();
    }
  };

  const renderStars = (currentRating) => {
    const handleMouseEnter = (rating) => {
      const stars = document.querySelectorAll('.star');
      stars.forEach((star, index) => {
        if (index <= rating - 1) {
          star.classList.add('hovered');
        } else {
          star.classList.remove('hovered');
        }
      });
    };

    const handleMouseLeave = () => {
      const stars = document.querySelectorAll('.star');
      stars.forEach(star => {
        star.classList.remove('hovered');
      });
    };

    return [...Array(5)].map((_, index) => {
      const starValue = index + 1;
      return (
        <span
          key={starValue}
          className={`star ${starValue <= currentRating ? 'selected' : ''}`}
          onClick={() => handleStarClick(starValue)}
          onMouseEnter={() => handleMouseEnter(starValue)}
          onMouseLeave={handleMouseLeave}
        >
          ★
        </span>
      );
    });
  };

  if (isFeedbackSubmitted) {
    return null;
  }

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <h2>Give Us Your Feedback</h2>

        <div className="star-rating-container">
          {renderStars(selectedRating)}
        </div>

        {selectedRating < 5 && (
          <div className="comment-box">
            <textarea
              placeholder="Please provide additional feedback"
              value={feedbackComment}
              onChange={handleCommentChange}
            />
          </div>
        )}

        <div className="helpfulness-section">
          <label>
            Was this feedback helpful?
            <input
              type="checkbox"
              checked={wasHelpful}
              onChange={handleHelpfulnessChange}
            />
          </label>
        </div>

        <button
          className="submit-btn"
          style={{ backgroundColor: '#0B89C2', color: 'white' }}
          onClick={handleSubmit}
          disabled={isSubmitted}
        >
          Submit Feedback
        </button>

        <button className="close-button" onClick={onClose}>x</button>
      </div>
    </div>
  );
};

export default FeedbackPopup;
